// extracted by mini-css-extract-plugin
export default {"dateReminder":"DateReminder-module__dateReminder___YA9Ft","wrapper":"DateReminder-module__wrapper___2MMRz","date":"DateReminder-module__date____mStb"};